
<div class="background">
    <app-website-header></app-website-header>
    <app-carousel></app-carousel>
    <div class="home">
      <img src="../../assets/images/icons/home-icon.svg" alt="" [routerLink]="['/']">
      <div [routerLink]="['/']">Home</div>
      <div [routerLink]="['/knowledge_center']">/ Knowledge Center</div>
    </div>
  
    <div class="heading-with-line">
      <div class="line1"></div>
      <div class="heading-text" style="font-weight: 600;font-size:18; font-family: 'Georgia' !important;">Knowledge Center</div>
      <div class="line2"></div>
    </div>
    <div class="card-container">
      <div class="card" [routerLink]="['/webinars']">
        <img src="../../../../assets/images/webinars(kc).jpg" alt="Webinars-img">
        <p>Webinars</p>
      </div>
      <div class="card" [routerLink]="['/conferences']">
        <img src="../../../../assets/images/conferences(kc).jpg" alt="conferences-img">
        <p>Conferences</p>
      </div>
      <div class="card" [routerLink]="['/blogs']">
        <img src="../../../../assets/images/blogs&community(kc).jpg" alt="Blogs&Community-img">
        <p>Blogs & Community</p>
      </div>
      <div class="card" [routerLink]="['/magazines']">
        <img src="../../../../assets/images/e-magazines(kc).jpg" alt="E-Magazines-img">
        <p>E-Magazines</p>
      </div>
      <div class="card" [routerLink]="['/journals']">
        <img src="../../../../assets/images/journals(kc).jpg" alt="Journals-img">
        <p>Journals</p>
      </div>
    </div>
    <app-website-footer></app-website-footer>
  </div>